import React, { useEffect, useState, useRef } from "react";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Heading from "components/Heading/Heading";
import NcImage from "shared/NcImage/NcImage";
import Textarea from "shared/Textarea/Textarea";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import StefanServiceClient from "services/stefanServiceClient";

function StefanHome() {
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState<{ sender: "user" | "stefan"; content: string }[]>([]);
  const [threadId, setThreadId] = useState("0");

  const chatContainerRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    const el = chatContainerRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  };

  useEffect(() => {
    document.body.classList.add("theme-purple-blueGrey");
    return () => document.body.classList.remove("theme-purple-blueGrey");
  }, []);

  useEffect(() => {
    const socket = new WebSocket("wss://mamtemoc.edu.pl/ws");

    socket.onopen = () => {
      console.log("Połączono z WebSocketem");
    };

    socket.onmessage = (event) => {
      const content = event.data;
      setMessages((prev) => [...prev, { sender: "stefan", content }]);
    };

    socket.onclose = () => {
      console.log("Połączenie WebSocket zamknięte");
    };

    socket.onerror = (error) => {
      console.error("WebSocket error", error);
    };

    return () => {
      socket.close();
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim()) return;

    setIsLoading(true);
    setMessages((prev) => [...prev, { sender: "user", content: input }]);

    new StefanServiceClient().ask(input, threadId, (result: any) => {
      const { answerType, answer, threadId } = result;

      setThreadId(threadId);
      setMessages((prev) => [...prev, { sender: "stefan", content: answer }]);
      setIsLoading(false);
    });

    setInput("");
  };

  return (
    <div className="nc-PageHome3 relative overflow-hidden">
      <BgGlassmorphism />
      <div className="container relative mt-24 mb-24">
        <div className="nc-SectionGridFilterCard pb-24 lg:pb-28 mt-10">
          <Heading isCenter>Stefan – Twój osobisty asystent</Heading>

          <div className="flex flex-col lg:flex-row items-start gap-8 mt-10">
            <NcImage
              src="/images/stefan.jpg"
              className="max-w-[300px] max-h-[300px] rounded-2xl group-hover:scale-105 transition-transform duration-300"
            />

            <div
              ref={chatContainerRef}
              className="flex-1 flex flex-col h-full w-full border rounded-2xl bg-white/50 dark:bg-black/20 p-4 space-y-4 overflow-y-auto max-h-[500px]"
            >
              {messages.map((msg, idx) => (
                <div key={idx} className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"}`}>
                  <div
                    className={`p-3 rounded-lg max-w-[70%] ${
                      msg.sender === "user" ? "bg-blue-500 text-white" : "bg-gray-200 dark:bg-gray-700 text-black dark:text-white"
                    }`}
                    dangerouslySetInnerHTML={{ __html: msg.content }}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="mt-6">
            <Textarea
              className="w-full"
              required
              placeholder="Twoja wiadomość do Stefana..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <div className="flex justify-center mt-4">
              <ButtonPrimary onClick={handleSend} disabled={isLoading}>
                {isLoading ? "Stefan pracuje dla Ciebie..." : "Wyślij"}
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StefanHome;
